"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminProvisionPage = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const Util_1 = __importDefault(require("@common/Util"));
const UI_1 = require("../util/UI");
const AdminDeliverablesTab_1 = require("./AdminDeliverablesTab");
const AdminPage_1 = require("./AdminPage");
const AdminView_1 = require("./AdminView");
const JobRunner_1 = require("./JobRunner");
class AdminProvisionPage extends AdminPage_1.AdminPage {
    constructor(remote) {
        super(remote);
        this.jobs = new JobRunner_1.JobRunner(remote);
        this.sections = this.buildSections();
    }
    init(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminProvisionPage::init(..) - start");
            UI_1.UI.showModal("Retrieving Deliverables.");
            this.deliverables = yield AdminDeliverablesTab_1.AdminDeliverablesTab.getDeliverables(this.remote);
            this.deliverables = this.deliverables.sort(function compare(a, b) {
                return a.id.localeCompare(b.id);
            });
            const delivOptions = [];
            delivOptions.push("-None-");
            for (const deliv of this.deliverables) {
                if (deliv.shouldProvision === true) {
                    delivOptions.push(deliv.id);
                }
            }
            UI_1.UI.setDropdownOptions("provisionRepoDeliverableSelect", delivOptions, null);
            this.clearLists();
            const delivSelector = document.querySelector("#provisionRepoDeliverableSelect");
            delivSelector.onchange = (evt) => {
                evt.stopPropagation();
                this.handleDelivChanged().catch(function (err) {
                    Log_1.default.warn("AdminProvisionPage::init(..) - handleDelivChanged ERROR: " + err);
                });
            };
            yield Promise.all(this.sections.map((section) => this.jobs.init(section)));
            UI_1.UI.hideModal();
        });
    }
    buildSections() {
        return [
            {
                kind: "provision-prepare",
                buttonId: "adminManagePrepareButton",
                statusId: "adminProvisionPrepareStatus",
                ran: "Last prepared",
                params: () => {
                    const delivId = AdminProvisionPage.selectedDeliverable();
                    if (delivId === null) {
                        UI_1.UI.showErrorToast("Select a deliverable first.");
                        return null;
                    }
                    const checkbox = document.querySelector("#provisionFormSingleCheckbox");
                    return { delivId: delivId, formSingle: checkbox !== null && checkbox.checked === true };
                },
                detail: function (summary) {
                    let detail = summary.delivId +
                        ": " +
                        summary.teamsCreated +
                        " team(s) and " +
                        summary.reposCreated +
                        " repository record(s) created; " +
                        summary.repos +
                        " repo(s) planned";
                    if (Array.isArray(summary.notPlaced) && summary.notPlaced.length > 0) {
                        const shown = summary.notPlaced
                            .slice(0, 8)
                            .map((n) => n.personId + " (" + n.kind + ")")
                            .join(", ");
                        const more = summary.notPlaced.length > 8 ? ", +" + (summary.notPlaced.length - 8) + " more" : "";
                        detail += "; <b>" + summary.notPlaced.length + " not placed</b>: " + shown + more + " -- " + summary.notPlaced[0].reason;
                    }
                    return detail + ".";
                },
                onTerminal: () => {
                    this.refreshLists();
                },
            },
            {
                kind: "provision-create",
                buttonId: "adminManageProvisionButton",
                cancelButtonId: "adminManageProvisionCancelButton",
                statusId: "adminProvisionCreateStatus",
                ran: "Last provisioned",
                confirmCancel: "Stop provisioning after the repositories currently being created finish?\n\n" +
                    "Repositories already created are kept; pressing Provision again creates the rest.",
                params: () => this.repoParams("repositoryProvisionSelect", "provisioning"),
                detail: AdminProvisionPage.describeRepoSummary("provisioned"),
                onTerminal: () => {
                    this.refreshLists();
                },
            },
            {
                kind: "provision-release",
                buttonId: "adminManageReleaseButton",
                cancelButtonId: "adminManageReleaseCancelButton",
                statusId: "adminProvisionReleaseStatus",
                ran: "Last released",
                confirmCancel: "Stop releasing after the current repository finishes?\n\n" +
                    "Repositories already released stay released; pressing Release again releases the rest.",
                params: () => this.repoParams("repositoryReleaseSelect", "releasing"),
                detail: AdminProvisionPage.describeRepoSummary("released"),
                onTerminal: () => {
                    this.refreshLists();
                },
            },
            {
                kind: "provision-unrelease",
                buttonId: "adminManageUnreleaseButton",
                cancelButtonId: "adminManageUnreleaseCancelButton",
                statusId: "adminProvisionUnreleaseStatus",
                ran: "Last un-released",
                confirmCancel: "Stop un-releasing after the current repository finishes?\n\n" +
                    "Repositories already un-released stay un-released; pressing Un-Release again does the rest.",
                params: () => this.repoParams("repositoryReleasedSelect", "un-releasing"),
                detail: AdminProvisionPage.describeRepoSummary("unreleased"),
                onTerminal: () => {
                    this.refreshLists();
                },
            },
            {
                kind: "provision-readonly",
                buttonId: "adminManageReadOnlyButton",
                cancelButtonId: "adminManageReadOnlyCancelButton",
                statusId: "adminProvisionReadOnlyStatus",
                ran: "Last made read-only",
                confirmCancel: "Stop after the repositories currently being changed finish?\n\n" +
                    "Repositories already made read-only stay read-only; pressing Make Read-only again does the rest.",
                params: () => this.repoParams("repositoryWriteableSelect", "making read-only"),
                detail: AdminProvisionPage.describeRepoSummary("changed", "made read-only"),
                onTerminal: () => {
                    this.refreshLists();
                },
            },
            {
                kind: "provision-writeable",
                buttonId: "adminManageWriteableButton",
                cancelButtonId: "adminManageWriteableCancelButton",
                statusId: "adminProvisionWriteableStatus",
                ran: "Last made writeable",
                confirmCancel: "Stop after the repositories currently being changed finish?\n\n" +
                    "Repositories already made writeable stay writeable; pressing Make Writeable again does the rest.",
                params: () => this.repoParams("repositoryReadOnlySelect", "making writeable"),
                detail: AdminProvisionPage.describeRepoSummary("changed", "made writeable"),
                onTerminal: () => {
                    this.refreshLists();
                },
            },
        ];
    }
    repoParams(selectId, action) {
        const delivId = AdminProvisionPage.selectedDeliverable();
        if (delivId === null) {
            UI_1.UI.showErrorToast("Select a deliverable first.");
            return null;
        }
        const repoIds = AdminProvisionPage.selectedOptions(selectId);
        if (repoIds.length === 0) {
            UI_1.UI.showErrorToast("No repos selected for " + action + ".");
            return null;
        }
        return { delivId: delivId, repoIds: repoIds };
    }
    static describeRepoSummary(field, label = field) {
        return function (summary) {
            var _a;
            let detail = summary.delivId + ": " + summary[field] + " of " + summary.requested + " " + label + ".";
            if (summary.skipped > 0) {
                detail += " " + summary.skipped + " already done.";
            }
            if (((_a = summary.failed) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                detail += " <b>" + summary.failed.length + " failed: " + summary.failed.slice(0, 5).join(", ") + "</b>";
                if (summary.failed.length > 5) {
                    detail += " (and " + (summary.failed.length - 5) + " more)";
                }
            }
            if (summary.cancelled === true) {
                detail += " Cancelled; press again to finish the rest.";
            }
            if (summary.stoppedEarly === true) {
                detail += " <b>Stopped early: " + summary.stopReason + "</b> Press again to continue.";
            }
            return detail;
        };
    }
    static selectedDeliverable() {
        const value = UI_1.UI.getDropdownValue("provisionRepoDeliverableSelect");
        if (typeof value !== "string" || value === "" || value === "-None-") {
            return null;
        }
        return value;
    }
    static selectedOptions(selectId) {
        const select = document.getElementById(selectId);
        const selected = [];
        if (select === null) {
            return selected;
        }
        for (const opt of select.options) {
            if (opt.selected && opt.disabled === false) {
                selected.push(opt.value || opt.text);
            }
        }
        return selected;
    }
    clearLists() {
        const toProvisionSelect = document.getElementById("repositoryProvisionSelect");
        const provisionedSelect = document.getElementById("repositoryProvisionedSelect");
        const toReleaseSelect = document.getElementById("repositoryReleaseSelect");
        const releasedSelect = document.getElementById("repositoryReleasedSelect");
        const writeableSelect = document.getElementById("repositoryWriteableSelect");
        const readOnlySelect = document.getElementById("repositoryReadOnlySelect");
        const delivSelect = document.getElementById("provisionRepoDeliverableSelect");
        delivSelect.disabled = false;
        toProvisionSelect.disabled = false;
        toReleaseSelect.disabled = false;
        toProvisionSelect.innerHTML = "";
        toReleaseSelect.innerHTML = "";
        if (provisionedSelect !== null) {
            provisionedSelect.innerHTML = "";
        }
        if (releasedSelect !== null) {
            releasedSelect.innerHTML = "";
        }
        if (writeableSelect !== null) {
            writeableSelect.innerHTML = "";
        }
        if (readOnlySelect !== null) {
            readOnlySelect.innerHTML = "";
        }
    }
    handleDelivChanged() {
        return __awaiter(this, void 0, void 0, function* () {
            const val = UI_1.UI.getDropdownValue("provisionRepoDeliverableSelect");
            Log_1.default.info("AdminProvisionPage::handleDelivChanged(..) - new deliverable selected: " + val);
            this.setFormSingleForDeliverable(val);
            if (val === "-None-") {
                this.clearLists();
                return;
            }
            UI_1.UI.showModal("Retrieving provisioning and releasing details for " + val + ".");
            try {
                yield this.refreshLists();
            }
            finally {
                UI_1.UI.hideModal();
            }
        });
    }
    setFormSingleForDeliverable(delivId) {
        var _a;
        const checkbox = document.querySelector("#provisionFormSingleCheckbox");
        if (checkbox === null) {
            return;
        }
        const deliv = ((_a = this.deliverables) !== null && _a !== void 0 ? _a : []).find((d) => d.id === delivId);
        const singleton = typeof deliv !== "undefined" && deliv.maxTeamSize === 1;
        checkbox.disabled = singleton;
        if (singleton === true) {
            checkbox.checked = true;
        }
    }
    refreshLists() {
        return __awaiter(this, void 0, void 0, function* () {
            const val = AdminProvisionPage.selectedDeliverable();
            if (val === null) {
                this.clearLists();
                return;
            }
            const toProvisionSelect = document.getElementById("repositoryProvisionSelect");
            const provisionedSelect = document.getElementById("repositoryProvisionedSelect");
            const toReleaseSelect = document.getElementById("repositoryReleaseSelect");
            const releasedSelect = document.getElementById("repositoryReleasedSelect");
            const writeableSelect = document.getElementById("repositoryWriteableSelect");
            const readOnlySelect = document.getElementById("repositoryReadOnlySelect");
            try {
                this.clearLists();
                const provisionRepo = yield this.getProvisionDetails(val);
                Log_1.default.info("AdminProvisionPage::refreshLists(..) - # repos known for " + val + ": " + provisionRepo.length);
                const provisioned = [];
                const toProvision = [];
                const writeable = [];
                const readOnly = [];
                for (const repo of provisionRepo) {
                    if (repo.gitHubStatus === "NOT_CREATED" || repo.gitHubStatus === "CREATED") {
                        toProvision.push(repo.id);
                    }
                    else {
                        provisioned.push(repo.id);
                    }
                    if (repo.gitHubStatus === "RELEASED") {
                        if (repo.studentAccess === "pull") {
                            readOnly.push(repo.id);
                        }
                        else {
                            writeable.push(repo.id);
                        }
                    }
                }
                AdminProvisionPage.fillSelect(writeableSelect, writeable.sort(), "No writeable repositories");
                AdminProvisionPage.fillSelect(readOnlySelect, readOnly.sort(), "No read-only repositories");
                AdminProvisionPage.fillSelect(provisionedSelect, provisioned.sort(), "No provisioned repositories");
                AdminProvisionPage.fillSelect(toProvisionSelect, toProvision.sort(), provisionRepo.length === 0 ? "Nothing planned yet; press Prepare" : "Nothing to provision");
                const reposToRelease = yield this.getReleaseDetails(val);
                Log_1.default.info("AdminProvisionPage::refreshLists(..) - # repos in release plan: " + reposToRelease.length);
                const released = [];
                const toRelease = [];
                for (const repo of reposToRelease) {
                    if (repo.gitHubStatus === "READY") {
                        toRelease.push(repo.id);
                    }
                    else {
                        released.push(repo.id);
                    }
                }
                AdminProvisionPage.fillSelect(releasedSelect, released.sort(), "No released repositories");
                AdminProvisionPage.fillSelect(toReleaseSelect, toRelease.sort(), "Nothing to release");
            }
            catch (err) {
                Log_1.default.error("AdminProvisionPage::refreshLists(..) - ERROR: " + err);
            }
        });
    }
    static fillSelect(select, names, emptyText) {
        if (select === null) {
            Log_1.default.warn("AdminProvisionPage::fillSelect(..) - list element missing from admin.html; rebuild the frontend");
            return;
        }
        if (names.length === 0) {
            const option = document.createElement("option");
            option.text = emptyText;
            option.disabled = true;
            select.add(option);
            return;
        }
        for (const name of names) {
            const option = document.createElement("option");
            option.text = name;
            select.add(option);
        }
    }
    getProvisionDetails(delivId) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminProvisionPage::getProvisionDetails( " + delivId + " ) - start");
            const url = this.remote + "/portal/admin/provision/" + delivId;
            const options = AdminView_1.AdminView.getOptions();
            options.method = "get";
            const start = Date.now();
            const response = yield fetch(url, options);
            const json = yield response.json();
            if (typeof json.success !== "undefined") {
                Log_1.default.info("AdminProvisionPage::getProvisionDetails(..) - success; took: " + Util_1.default.took(start));
                return json.success;
            }
            else {
                Log_1.default.error("AdminProvisionPage::getProvisionDetails(..) - ERROR: " + json.failure);
            }
            return [];
        });
    }
    getReleaseDetails(delivId) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("AdminProvisionPage::getReleaseDetails( " + delivId + " ) - start");
            const url = this.remote + "/portal/admin/release/" + delivId;
            const options = AdminView_1.AdminView.getOptions();
            options.method = "get";
            const start = Date.now();
            const response = yield fetch(url, options);
            const json = yield response.json();
            if (typeof json.success !== "undefined") {
                Log_1.default.info("AdminProvisionPage::getReleaseDetails(..) - success; took: " + Util_1.default.took(start));
                return json.success;
            }
            else {
                Log_1.default.error("AdminProvisionPage::getReleaseDetails(..) - ERROR: " + json.failure);
            }
            return [];
        });
    }
    renderPage(pageName, opts) {
        Log_1.default.info("AdminProvisionPage::renderPage( " + pageName + ", ... ) - start");
    }
}
exports.AdminProvisionPage = AdminProvisionPage;
